let priceFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});

if (document.getElementById('bundler')) {
    // prettier-ignore
    const skusToCheck = ['WGLC1', 'WGLC2', 'WGLC5', 'WGLC10S', 'WGLC15S', 'WGLC20S', 'MLC1', 'MLC2', 'MLC5', 'MLC10S', 'MLC15S', 'MLC20S', 'SLC1', 'SLC2', 'SLC5', 'SLC10S', 'SLC15S', 'SLC20S', 'BOLC1', 'BOLC2', 'BOLC5', 'BOLC10S', 'BOLC15S', 'BOLC20S', 'PLC1', 'PLC2', 'PLC5', 'PLC10S', 'PLC15S', 'PLC20S', 'SP1', 'SP2', 'SP5', 'SP10S', 'SP15S', 'SP20S', 'WGP1', 'WP2', 'WP5', 'WP10S', 'WP15S', 'WP20S', 'MP1', 'MP2', 'MP5', 'MP10S', 'MP15S', 'MP20S'];

    var bundleVm = new Vue({
        el: '#bundler',
        delimiters: ['${', '}'],
        data: {
            filter: '',
            collections: collections_bundles,
            bundle: [],
            bundleCnt: 1,
            showBundleDetails: false,
            originalPrice: false
        },
        methods: {
            formatMoney(p) {
                return priceFormatter.format(p);
            },
            scrollLeft(id) {
                let $elem = $('[data-collection=' + id + ']');
                let left = $elem.scrollLeft();
                let inc = $elem.width() + 15;
                left -= inc;
                left = Math.floor(left / inc) * inc;

                if (left < 0) left = 0;
                $elem.animate({
                    scrollLeft: left
                }, 500);
            },
            scrollRight(id) {
                let $elem = $('[data-collection=' + id + ']');
                let left = $elem.scrollLeft();
                let inc = $elem.width() + 15;
                left += inc;
                left = Math.floor(left / inc) * inc;
                $elem.animate({
                    scrollLeft: left
                }, 500);
            },
            validBundle() {
                let count = this.getBundleTotal();
                return count == 2 || count == 5;
            },
            getBundleTotal() {
                let total = 0;
                this.bundle.map(function (product) {
                    total += product.quantity;
                });
                return total;
            },
            incrementBundle(product) {
                if (this.getBundleTotal() >= 5) {
                    return;
                }

                for (var i = 0; i < this.bundle.length; i++) {
                    if (product.id == this.bundle[i].id) {
                        this.bundle[i].quantity++;
                    }
                }
            },
            decrementBundle(product) {
                let toDelete = -1;
                for (var i = 0; i < this.bundle.length; i++) {
                    if (product.id == this.bundle[i].id) {
                        this.bundle[i].quantity--;

                        if (this.bundle[i].quantity == 0)
                            toDelete = i;
                    }
                }

                if (toDelete >= 0) {
                    this.bundle.splice(toDelete, 1);
                }
            },
            addToBundle(product) {
                if (this.getBundleTotal() >= 5) {
                    return;
                }

                let added = false;
                for (var i = 0; i < this.bundle.length; i++) {
                    if (product.id == this.bundle[i].id) {
                        this.bundle[0].quantity++;
                    }
                }
                if (!added) {
                    product.quantity = 1;
                    this.bundle.push(product);
                }
            },
            incrementBundleCount() {
                this.bundleCnt++;
            },
            decrementBundleCount() {
                if (this.bundleCnt > 1)
                    this.bundleCnt--;
            },
            bundleCount(id) {
                let count = 0;
                this.bundle.map(function (product) {
                    if (product.id == id)
                        count = product.quantity;
                });

                return count;
            },
            bundlePrice() {
                let price = 0;
                this.bundle.map(function (product) {
                    price += product.price * product.quantity;
                });

                this.originalPrice = false;
                if (this.getBundleTotal() == 5) {
                    this.originalPrice = price;
                    price = 27.45;
                }

                return price * this.bundleCnt;
            },
            async addBundleToCart() {
                let items = [];
                const properties = {
                    'Bundle': Math.random().toString(36).substring(2, 7),
                    'Bundle Qty': this.bundleCnt.toString(),
                    'Bundle Size': this.getBundleTotal().toString()
                };

                for (let i = 0; i < this.bundle.length; i++) {
                    items.push({
                        quantity: this.bundle[i].quantity * this.bundleCnt,
                        id: this.bundle[i].variant,
                        properties: properties
                    });
                }

                try {
                    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                    const config = fetchConfig('javascript');
                    config.headers['X-Requested-With'] = 'XMLHttpRequest';
                    config.body = JSON.stringify({
                        items: items,
                        sections: cart.getSectionsToRender().map((section) => section.id),
                        sections_url: window.location.pathname
                    });
                    let response = await fetch(`${routes.cart_add_url}`, config);
                    let data = { ...(await response.json()), id: 0 };

                    if (_compliance_sticker_id) {
                        const newItemId = parseInt(_compliance_sticker_id);
                        const newItemQuantity = parseInt(_compliance_sticker_qty);
                        const _response = await fetch('/cart.js');
                        const _cart = await _response.json();
                        const skuExists = _cart.items.some((item) => skusToCheck.includes(item.sku));
                        const itemExists = _cart.items.some((item) => parseInt(item.id) === newItemId);
                        if (!itemExists && skuExists) {
                            let _items = [{
                                quantity: newItemQuantity,
                                id: newItemId
                            }];
                            config.body = JSON.stringify({
                                items: _items,
                                sections: cart.getSectionsToRender().map((section) => section.id),
                                sections_url: window.location.pathname
                            });
                            response = await fetch(`${routes.cart_add_url}`, config);
                            data = { ...(await response.json()), id: 0 };
                        }
                    }

                    cart.renderContents(data);
                    if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                    if (cart) cart.classList.add('add-new-product');
                    this.bundle = [];
                    this.bundleCnt = 1;
                } catch (error) {
                    console.error('Error:', error);
                }
            }

        }
    });
}

/*
$(window).on('scroll', function () {
    let top = $(window).scrollTop();

    if (top > 300) {
        $('.bundle-top').addClass('fixed');
        $('.bundle-cart').addClass('fixed');
        $('#bundler .configurator').addClass('fixed');
    }
    else {
        $('.bundle-top').removeClass('fixed');
        $('.bundle-cart').removeClass('fixed');
        $('#bundler .configurator').removeClass('fixed');
    }
});
*/